import { useMemo, useState } from 'react';
import { FindRelatedFilesRes } from '@dealstack/shared/lib/generated';

export const useManageFileAssociationStep = ({
	relatedFilesInDeal,
	setRelatedFilesInDeal,
}: {
	relatedFilesInDeal: FindRelatedFilesRes[] | undefined;
	setRelatedFilesInDeal: (relatedFilesInDeal: FindRelatedFilesRes[]) => void;
}) => {
	const [selectedFile, setSelectedFile] = useState<FindRelatedFilesRes>();

	const toggleShouldLinkRelatedTransaction = (transactionId: string) => {
		const updatedTransactions = relatedTransactions?.map((transaction) => {
			if (transaction.transactionId === transactionId) {
				return {
					...transaction,
					shouldLink: !transaction.shouldLink,
				};
			}
			return transaction;
		});

		if (!updatedTransactions) {
			return;
		}

		const updatedRelatedFilesInDeal = relatedFilesInDeal?.map((file) => {
			if (file.md5 === selectedFile?.md5) {
				// merge the change back in
				return {
					...file,
					relatedTransactions: updatedTransactions,
				};
			}
			return file;
		});

		setRelatedFilesInDeal(updatedRelatedFilesInDeal ?? []);
	};

	const linkedTransactions = useMemo(
		() => relatedFilesInDeal?.find((file) => file.md5 === selectedFile?.md5)?.matchedDocuments,
		[relatedFilesInDeal, selectedFile]
	);

	const relatedTransactions = useMemo(
		() =>
			relatedFilesInDeal?.find((file) => file.md5 === selectedFile?.md5)?.relatedTransactions,
		[relatedFilesInDeal, selectedFile]
	);

	return {
		selectedFile,
		setSelectedFile,
		toggleShouldLinkRelatedTransaction,
		linkedTransactions,
		relatedTransactions,
	};
};
